<template lang="pug">
  v-container.fill-height.align-start.pa-0(fluid)
    v-snackbar(v-model="showSnackBar" :color="snackbarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle

    v-row.ma-0
      v-col.px-0(cols="12" md="6" v-if="!isDeliveryBoy")
        DashboardReservationSummary(@fetchData="fetchSummaryData" @actuallyDate="actuallyDate" :summaryData="summaryData" :date="date" :data="data" :loading="loading")
      v-col.px-0(cols="12" md="6" v-if="isDeliveryBoy")
        DashboardReservationSummaryDetail()

</template>

<script lang="ts">
import Vue from 'vue'
import {usePiniaStore} from "@/store/piniaStore";
import {Component} from "vue-property-decorator";
import moment from "moment";
import DashboardReservationSummary from "@/components/DashboardReservationSummary.vue";
import DashboardReservationSummaryDetail from "@/components/DashboardReservationSummaryDetail.vue";
import _ from "lodash";
import {COUNTDOWN} from "@/constants";
import {CurrentUser} from "@/model/CurrentUser";
import {USER_LOGGED_IN} from "@/store/getter-types";
import MenuGroupSummary from "@/model/MenuGroupSummary";
import {MenuGroupSlotSummaryResponse} from "@/types/service-response";

interface ReservationSummary {
  title: string;
  value: number;
  food: string;
  status: boolean;
  icon: string;
  totalPortion: number;
  order: number;
}

@Component({
    components: {
        DashboardReservationSummaryDetail,
        DashboardReservationSummary,
    }
})

export default class DashboardPage extends Vue {

    private summaryData: MenuGroupSummary[] | null =  []
    private piniaStore = usePiniaStore()
    private data: Map<string, {title: string, value: number}[]> = new Map();
    private date: string = moment().format('YYYY-MM-DD')
    private actuallyDate: string = ''
    private loading: boolean = false
    private showSnackBar: boolean = false
    private snackbarColor: string = ''
    private snackBarMessage: string | null = null
    private timeOutId: any | null = null

  get currentUser(): CurrentUser {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get isDeliveryBoy(): boolean {
    return this.currentUser.staffRoleList[0].role.name === 'delivery_boy'
  }


    countDownTimer () {
      this.timeOutId = setTimeout(() => {
        this.fetchSummaryData(this.date)
      },COUNTDOWN)
    }

    async fetchSummaryData (payload: string): Promise<void> {
      this.currentUser
      clearTimeout(this.timeOutId)
      this.date = payload

      this.loading = true
      try {
        const response = await this.piniaStore.fetchSummaryMenuGroupSlot(payload)
        this.loading = false
        this.summaryData = response.data

        this.data = this.createDataMapForReservationSummary(this.summaryData)
      } catch (e) {
        this.showSnackBar = true
        this.snackbarColor = 'error'
        this.snackBarMessage = this.$t('errors.fetchDataError').toString()
      } finally {
        this.countDownTimer()
      }

  }

  beforeDestroy () {
    clearTimeout(this.timeOutId)
  }

  mounted() {
    this.fetchSummaryData(this.date)
  }

  createDataMapForReservationSummary(summaryData: MenuGroupSummary[] | null): Map<string, ReservationSummary[]> {
    const groupedData = new Map<string, any[]>()

    summaryData?.forEach(summary => {
      summary.menuGroupSlotSummary.forEach(slotSummary => {
        const menuGroup = slotSummary.menuGroupSlot.menuGroup;
        const itemEntry: ReservationSummary = {
          title: slotSummary.menuGroupSlot.code,
          value: slotSummary.collatedStatusSummary.portionsToBeDeliveredCount += slotSummary.collatedStatusSummary.portionsDeliveredCount,
          food: slotSummary.foodItemTitle,
          status: true,
          icon: menuGroup.tags[0]?.iconClass || '',
          totalPortion: slotSummary.totalPortionsCount,
          order: slotSummary.menuGroupSlot.order
        }

          if (!groupedData.has(menuGroup.title)) {
            groupedData.set(menuGroup.title,[itemEntry])
          } else {
            let foundItem: any | undefined = groupedData.get(menuGroup.title)!.find((i: any) => i.title ===  itemEntry.title)
            if(foundItem){
              foundItem.value = foundItem.value + itemEntry.value
            } else {
              groupedData.get(menuGroup.title)!.push(itemEntry)
            }
          }
      })
    })
    return groupedData
  }
}
</script>

<style lang="stylus" scoped>
  .style
    background-color #cecdcd
  .text-style
    background-color white
  .toolbar-style
    background-color white
  .block
    text-align center
    margin 2%
    font-size 1.2em
    background-color #f4f4f4

</style>
